import { Form, FormInstance, Modal } from "antd";
import { MODAL_MASK_COLOR } from "../../../../../../../../../lib/constants";
import { useCallback, useMemo } from "react";
import "../PrintTaxModal/styles.scss";
import { FormButtons } from "../PrintTaxModal/components/FormButtons";
import { FormContent } from "./components/FormContent";
import { usePrint } from "./hooks/usePrint";
import { Dayjs } from "dayjs";

type PrintHistoryModalPros = {
  contractId: string;
  historyType: 0 | 1 | 2;
  range: [Dayjs, Dayjs];
  setHistoryType: React.Dispatch<React.SetStateAction<0 | 1 | 2>>;
};

export const PrintHistoryModal = ({
  contractId,
  historyType,
  range,
  setHistoryType,
}: PrintHistoryModalPros) => {
  const [form]: FormInstance[] = Form.useForm();

  const close = useCallback(() => {
    setHistoryType(0);
    form.resetFields();
  }, [setHistoryType, form]);

  const title: string = useMemo(
    () => `Print ${historyType === 1 ? "Payer" : "Payee"} History Report`,
    [historyType]
  );

  const { onPrint, disabled } = usePrint(contractId, form, historyType, close);

  return (
    <Modal
      open={historyType !== 0}
      title={title}
      width={315}
      onCancel={close}
      centered
      maskStyle={{ backgroundColor: MODAL_MASK_COLOR }}
      wrapClassName="z-1000 position-fixed"
      className="bordered-modal print-tax-modal"
      footer={
        <FormButtons disabled={disabled} close={close} onSave={onPrint} />
      }
      destroyOnClose
    >
      <FormContent
        disabled={disabled}
        form={form}
        contractId={contractId}
        type={historyType}
        range={range}
      />
    </Modal>
  );
};
